import { render } from "./myLogo.vue?vue&type=template&id=2ba17916&scoped=true"
import script from "./myLogo.vue?vue&type=script&lang=js"
export * from "./myLogo.vue?vue&type=script&lang=js"

import "./myLogo.vue?vue&type=style&index=0&id=2ba17916&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ba17916"]])

export default __exports__